import { Tabs, Image } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useState } from "react";
import tabImg from "../assets/images/visaIcon.svg";
import { ReactComponent as DoubleCheck } from "../assets/images/doubleCheck.svg";

const inclusions = [
  "To and fro economy class air travel for ‘Mumbai to Mumbai Tour’ guests as mentioned in the itinerary",
  "Airfare, Airport taxes and Visa Fees",
  "Baggage Allowance as per the airline policy",
  "Tour Manager Services throughout the tour",
  "Travel by comfortable A/C coach as per the tour itinerary",
  "Entrance fees of all sightseeing places to be visited from inside",
  "Accommodation in comfortable and convenient hotels on twin sharing basis",
];

const VisaDetailTabs = () => {
  const [activeKey, setActiveKey] = useState("1");
  return (
    <div className="container">
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        defaultActiveKey="1"
         
        className="pt-4 
            [&_.ant-tabs-nav]:border-t
            [&_.ant-tabs-nav]:mb-0
            [&_.ant-tabs-nav]:pl-3
            [&_.ant-tabs-tab]:outline-none 
            [&_.ant-tabs-tab]:!m-0 
            [&_.ant-tabs-ink-bar]:hidden
            [&_.ant-tabs-tab-btn]:border-r 
            [&_.ant-tabs-tab-btn]:px-10 
          [&_.ant-tabs-tab-btn]:border-gray-200
            [&_.ant-tabs-tab]:shadow-none 
            [&_.ant-tabs-tab:focus]:outline-none 
            [&_.ant-tabs-tab:focus]:shadow-none 
            [&_.ant-tabs-tab.ant-tabs-tab-active]:shadow-none 
            [&_.ant-tabs-content-holder]:px-8 [&_.ant-tabs-content-holder]:py-8
            [&_.ant-tabs-content-holder]:border-l [&_.ant-tabs-content-holder]:border-r [&_.ant-tabs-content-holder]:border-b 
        "
        items={[
          {
            key: "0",
            disabled: true,
            label: (
              <span
                className={`focus:outline-none focus:ring-0 ring-0 pb-2 text-base ${
                  activeKey === "1"
                    ? "text-danger font-semibold focus:outline-none"
                    : "text-[#8C95A7] font-normal focus:outline-none"
                }`}
              >
                <Image preview={false} src={tabImg} />
              </span>
            ),
          },
          {
            key: "1",
            label: (
              <span
                className={`focus:outline-none focus:ring-0 ring-0 pb-2 text-base ${
                  activeKey === "1"
                    ? "text-danger font-semibold focus:outline-none"
                    : "text-[#8C95A7] font-normal focus:outline-none"
                }`}
              >
               Visa Overview
              </span>
            ),
            children: (
              <ul className="mt-4 space-y-3">
                {inclusions.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start gap-3 text-sm font-normal"
                  >
                    <DoubleCheck className="mt-1 mb-3" />
                    <span className="text-black">{item}</span>
                  </li>
                ))}
              </ul>
            ),
          },
          {
            key: "2",
            label: (
              <span
                className={`pb-2 text-base ${
                  activeKey === "2"
                    ? "text-danger font-semibold"
                    : "text-[#8C95A7] font-normal"
                }`}
              >
                Visa Documents
              </span>
            ),
            children: (
              <p className="mt-4 text-base text-gray-600">
                Visa Documents content goes here...
              </p>
            ),
          },
          {
            key: "3",
            label: (
              <span
                className={`pb-2 text-base ${
                  activeKey === "3"
                    ? "text-danger font-semibold"
                    : "text-[#8C95A7] font-normal"
                }`}
              >
                How to apply
              </span>
            ),
            children: (
              <p className="mt-4 text-base text-gray-600">
                How to apply content goes here...
              </p>
            ),
          },
          {
            key: "4",
            label: (
              <span
                className={`pb-2 text-base ${
                  activeKey === "3"
                    ? "text-danger font-semibold"
                    : "text-[#8C95A7] font-normal"
                }`}
              >
                Terms & Conditions
              </span>
            ),
            children: (
              <p className="mt-4 text-base text-gray-600">
                Terms & Conditions content goes here...
              </p>
            ),
          },

          
        ]}
      />
    </div>
  );
};

export default VisaDetailTabs;
